import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Theme } from '@silvertours/front-shared';
import Airport from '@engineering/icons/airport';
import CityStation from '@engineering/icons/city-station';
import TrainStation from '@engineering/icons/train-station';

const IconAirport = styled(Airport)`
  height: 1.5rem;
  width: 1.5rem;
  fill: currentcolor;
`;
const IconCity = styled(CityStation)`
  height: 1.5rem;
  width: 1.5rem;
  fill: currentcolor;
`;
const IconRail = styled(TrainStation)`
  height: 1.5rem;
  width: 1.5rem;
  fill: currentcolor;
`;

const DisplayExpressionWrapper = styled.span`
  width: 1.5rem;
  grid-row: span 2 / span 2;
  margin-right: 1rem;
  display: flex;
  flex-shrink: 0;
  align-items: center;
`;

const ListWrapperBaseStyle = css`
  position: absolute;
  top: 3.75rem;
  left: 0;
  z-index: 50;
  max-height: 25rem;
  width: 100%;
  overflow-y: auto;
  border-radius: 0.5rem;
  border-width: 0.125rem;
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 10%),
    0 2px 4px -2px rgb(0 0 0 / 10%);
`;

const ResultsListWrapper = styled.ul`
  ${ListWrapperBaseStyle}
  border-color: ${({ theme }) => theme.color.highlightPrimary30};
  background-color: ${({ theme }) => theme.color.white};
`;

type ResultButtonProps = {
  selected: boolean;
};

const ResultsItemBaseStyle = css`
  padding: 0.75rem 1.5rem;
  display: flex;
  border-bottom-width: 0.0625rem;
  font-size: 1.063rem;
  font-weight: 100;
  line-height: 1.412em;

  ${Theme.mq('lg')} {
    font-size: 1.125rem;
    line-height: 1.333em;
  }
`;

const ResultItem = styled.button<ResultButtonProps>`
  ${ResultsItemBaseStyle};
  border-bottom-color: ${({ theme }) => theme.color.highlightPrimary30};
  width: 100%;
  cursor: pointer;
  text-align: left;
  outline-width: 0;
  background-color: ${({ selected, theme }) =>
    selected && theme.color.highlightPrimary30};

  &:hover {
    background-color: ${({ theme }) => theme.color.highlightPrimary30};
  }
`;

const NoResultsItemWrapper = styled.div`
  ${ListWrapperBaseStyle}
  border-color: ${({ theme }) => theme.color.highlightPrimary};
  background-color: ${({ theme }) => theme.color.white};
`;

const NoResultsItem = styled.p`
  ${ResultsItemBaseStyle};
  border-bottom-color: ${({ theme }) => theme.color.highlightPrimary};
`;

export {
  DisplayExpressionWrapper,
  IconAirport,
  IconCity,
  IconRail,
  ResultsListWrapper,
  ResultItem,
  NoResultsItemWrapper,
  NoResultsItem,
};
